import * as Yup from 'yup'

export const exameSchema = Yup.object().shape({
  setor: Yup.object().nullable().required('Setor é obrigatório'),
  cargo: Yup.object().nullable().required('Cargo é obrigatório'),
  exame: Yup.string().required('O nome do exame é obrigatório'),
})
